
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import Card from '../../components/base/Card';

export default function ListingDetailPage() {
  const navigate = useNavigate();
  const [showReservationModal, setShowReservationModal] = useState(false);

  // Datos de ejemplo de la cancha
  const listing = {
    id: 1,
    name: 'Cancha Los Campeones',
    location: 'Polanco, Ciudad de México',
    category: 'Fútbol 11',
    price: 800,
    rating: 4.8,
    reviews: 156,
    image: 'https://readdy.ai/api/search-image?query=professional%20soccer%20field%20with%20green%20artificial%20turf%2C%20stadium%20lights%2C%20goal%20posts%2C%20modern%20sports%20facility%2C%20well%20maintained%20pitch%2C%20bright%20lighting%2C%20realistic%20sports%20venue&width=1200&height=600&seq=listing-detail-main&orientation=landscape',
    features: ['Césped sintético', 'Iluminación LED', 'Estacionamiento', 'Vestidores'],
    publisher: 'Juan Carlos López',
    publisherAvatar: 'https://readdy.ai/api/search-image?query=mexican%20male%20user%20profile%20photo%2C%20casual%20friendly%20appearance%2C%20young%20adult%2C%20clean%20background&width=100&height=100&seq=publisher-detail&orientation=squarish',
    phone: '+52 55 1234 5678',
    email: 'contacto@loscampeones.com',
    description: 'Cancha profesional de fútbol 11 con césped sintético de última generación. Perfecta para partidos oficiales, entrenamientos y torneos. Contamos con todas las comodidades necesarias para una experiencia deportiva de primer nivel.',
    gallery: [
      'https://readdy.ai/api/search-image?query=professional%20soccer%20field%20aerial%20view%2C%20green%20artificial%20turf%2C%20stadium%20lights%2C%20modern%20sports%20facility&width=400&height=300&seq=gallery1&orientation=landscape',
      'https://readdy.ai/api/search-image?query=soccer%20field%20changing%20rooms%2C%20modern%20locker%20rooms%2C%20clean%20facilities%2C%20sports%20center%20amenities&width=400&height=300&seq=gallery2&orientation=landscape',
      'https://readdy.ai/api/search-image?query=soccer%20field%20parking%20lot%2C%20sports%20facility%20parking%20area%2C%20well%20organized%20parking%20space&width=400&height=300&seq=gallery3&orientation=landscape',
      'https://readdy.ai/api/search-image?query=soccer%20field%20bleachers%2C%20stadium%20seating%2C%20sports%20venue%20stands%2C%20spectator%20area&width=400&height=300&seq=gallery4&orientation=landscape'
    ]
  };

  const handleReserveNow = () => {
    setShowReservationModal(true);
  };

  const handleCloseReservation = () => {
    setShowReservationModal(false);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Breadcrumb */}
      <section className="bg-gray-50 py-4 border-b">
        <div className="container mx-auto px-4">
          <div className="flex items-center space-x-2 text-sm">
            <button
              onClick={() => navigate('/')}
              className="text-gray-600 hover:text-green-600 cursor-pointer"
            >
              Inicio
            </button>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <button
              onClick={() => navigate('/anuncio')}
              className="text-gray-600 hover:text-green-600 cursor-pointer"
            >
              Anuncios
            </button>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-800 font-medium">{listing.name}</span>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-8">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            {/* Header Section */}
            <div className="mb-8">
              <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-6">
                <div className="flex-1">
                  <h1 className="text-4xl font-bold text-gray-800 mb-3">{listing.name}</h1>
                  <div className="flex items-center text-gray-600 mb-3">
                    <i className="ri-map-pin-line mr-2 text-lg"></i>
                    <span className="text-lg">{listing.location}</span>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-medium">
                      {listing.category}
                    </span>
                    <div className="flex items-center">
                      <i className="ri-star-fill text-yellow-500 mr-1 text-lg"></i>
                      <span className="font-bold text-xl">{listing.rating}</span>
                      <span className="text-gray-500 ml-1">({listing.reviews} reseñas)</span>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-5xl font-bold text-green-600 mb-2">
                    ${listing.price}
                    <span className="text-xl text-gray-600">/hora</span>
                  </div>
                  <Button onClick={handleReserveNow} className="w-full md:w-auto px-8 py-3 text-lg whitespace-nowrap">
                    <i className="ri-calendar-check-line mr-2"></i>
                    Reservar Ahora
                  </Button>
                </div>
              </div>

              {/* Publisher Info */}
              <Card className="p-4 bg-gray-50 border-2 border-gray-200">
                <div className="flex items-center space-x-4">
                  <img
                    src={listing.publisherAvatar}
                    alt={listing.publisher}
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm text-gray-500">Publicado por</p>
                    <p className="text-xl font-bold text-gray-800">{listing.publisher}</p>
                  </div>
                </div>
              </Card>
            </div>

            {/* Main Image */}
            <div className="mb-8">
              <img
                src={listing.image}
                alt={listing.name}
                className="w-full h-96 md:h-[500px] object-cover object-top rounded-lg shadow-lg"
              />
            </div>

            {/* Gallery */}
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Galería de Imágenes</h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {listing.gallery.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Galería ${index + 1}`}
                    className="w-full h-48 object-cover object-top rounded-lg shadow hover:shadow-lg transition-shadow cursor-pointer"
                  />
                ))}
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Left Column - Main Info */}
              <div className="lg:col-span-2 space-y-8">
                {/* Description */}
                <Card className="p-6">
                  <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                    <i className="ri-file-text-line text-green-600 mr-2"></i>
                    Descripción
                  </h2>
                  <p className="text-gray-700 leading-relaxed">{listing.description}</p>
                </Card>

                {/* Features */}
                <Card className="p-6">
                  <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                    <i className="ri-checkbox-circle-line text-green-600 mr-2"></i>
                    Características Principales
                  </h2>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    {listing.features.map((feature, index) => (
                      <div key={index} className="flex items-center bg-gray-50 p-3 rounded-lg border border-gray-200">
                        <i className="ri-check-line text-green-600 mr-2"></i>
                        <span className="text-sm font-medium text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </Card>

                {/* Field Specifications */}
                <Card className="p-6">
                  <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                    <i className="ri-ruler-line text-green-600 mr-2"></i>
                    Especificaciones de la Cancha
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                      <div className="text-sm text-gray-600 mb-1">Dimensiones</div>
                      <div className="font-bold text-gray-800">
                        {listing.category === 'Fútbol 11' && '105m x 68m'}
                        {listing.category === 'Fútbol 7' && '65m x 45m'}
                        {listing.category === 'Fútbol 5' && '40m x 20m'}
                        {listing.category === 'Futsal' && '40m x 20m'}
                      </div>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                      <div className="text-sm text-gray-600 mb-1">Superficie</div>
                      <div className="font-bold text-gray-800">
                        {listing.features.includes('Césped sintético') ? 'Césped Sintético' :
                         listing.features.includes('Césped natural') ? 'Césped Natural' :
                         listing.features.includes('Piso de madera') ? 'Piso de Madera' : 'Césped Premium'}
                      </div>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                      <div className="text-sm text-gray-600 mb-1">Iluminación</div>
                      <div className="font-bold text-gray-800">
                        {listing.features.includes('Iluminación LED') ? 'LED Profesional' : 'Iluminación Estándar'}
                      </div>
                    </div>
                  </div>
                </Card>

                {/* Services and Amenities */}
                <Card className="p-6">
                  <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                    <i className="ri-service-line text-green-600 mr-2"></i>
                    Servicios y Comodidades
                  </h2>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                    {[
                      { icon: 'ri-parking-line', label: 'Estacionamiento', available: listing.features.includes('Estacionamiento') },
                      { icon: 'ri-door-line', label: 'Vestidores', available: listing.features.includes('Vestidores') },
                      { icon: 'ri-water-flash-line', label: 'Duchas', available: true },
                      { icon: 'ri-shield-check-line', label: 'Seguridad 24/7', available: true },
                      { icon: 'ri-restaurant-line', label: 'Cafetería', available: true },
                      { icon: 'ri-wifi-line', label: 'WiFi Gratis', available: true },
                      { icon: 'ri-first-aid-kit-line', label: 'Primeros Auxilios', available: true },
                      { icon: 'ri-t-shirt-line', label: 'Alquiler de Equipos', available: true },
                      { icon: 'ri-store-line', label: 'Tienda Deportiva', available: false }
                    ].map((service, index) => (
                      <div
                        key={index}
                        className={`flex items-center p-3 rounded-lg border ${
                          service.available
                            ? 'bg-green-50 border-green-200'
                            : 'bg-gray-50 border-gray-200 opacity-50'
                        }`}
                      >
                        <i className={`${service.icon} ${service.available ? 'text-green-600' : 'text-gray-400'} mr-2 text-lg w-5 h-5 flex items-center justify-center`}></i>
                        <span className={`text-sm font-medium ${service.available ? 'text-gray-800' : 'text-gray-500'}`}>
                          {service.label}
                        </span>
                      </div>
                    ))}
                  </div>
                </Card>

                {/* Availability Schedule */}
                <Card className="p-6">
                  <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                    <i className="ri-calendar-line text-green-600 mr-2"></i>
                    Horarios de Disponibilidad
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                      <div className="font-bold text-gray-800 mb-2 flex items-center">
                        <i className="ri-calendar-check-line text-green-600 mr-2"></i>
                        Lunes a Viernes
                      </div>
                      <div className="text-gray-600">6:00 AM - 11:00 PM</div>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                      <div className="font-bold text-gray-800 mb-2 flex items-center">
                        <i className="ri-calendar-event-line text-green-600 mr-2"></i>
                        Sábados y Domingos
                      </div>
                      <div className="text-gray-600">7:00 AM - 10:00 PM</div>
                    </div>
                  </div>
                </Card>
              </div>

              {/* Right Column - Sidebar */}
              <div className="lg:col-span-1">
                <div className="sticky top-24 space-y-6">
                  {/* Contact Card */}
                  <Card className="p-6 bg-gradient-to-br from-green-50 to-green-100 border-2 border-green-200">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                      <i className="ri-contacts-line text-green-600 mr-2"></i>
                      Información de Contacto
                    </h3>
                    <div className="space-y-3">
                      <div className="flex items-center">
                        <i className="ri-phone-line text-green-600 mr-3 text-xl w-6 h-6 flex items-center justify-center"></i>
                        <div>
                          <div className="text-xs text-gray-600">Teléfono</div>
                          <div className="font-medium text-gray-800">{listing.phone}</div>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <i className="ri-mail-line text-green-600 mr-3 text-xl w-6 h-6 flex items-center justify-center"></i>
                        <div>
                          <div className="text-xs text-gray-600">Email</div>
                          <div className="font-medium text-gray-800">{listing.email}</div>
                        </div>
                      </div>
                      <div className="flex items-start">
                        <i className="ri-map-pin-line text-green-600 mr-3 text-xl w-6 h-6 flex items-center justify-center mt-1"></i>
                        <div>
                          <div className="text-xs text-gray-600">Dirección</div>
                          <div className="font-medium text-gray-800">{listing.location}</div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-6">
                      <button
                        onClick={handleReserveNow}
                        className="w-full px-4 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
                      >
                        <i className="ri-calendar-check-line text-xl"></i>
                        Reservar Ahora
                      </button>
                    </div>
                  </Card>

                  {/* Statistics */}
                  <Card className="p-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                      <i className="ri-bar-chart-line text-green-600 mr-2"></i>
                      Estadísticas
                    </h3>
                    <div className="space-y-4">
                      <div className="flex items-center justify-between p-3 bg-blue-50 rounded-lg">
                        <div className="flex items-center">
                          <i className="ri-eye-line text-blue-600 text-xl mr-2"></i>
                          <span className="text-sm text-gray-700">Visualizaciones</span>
                        </div>
                        <span className="font-bold text-blue-600">{Math.floor(listing.reviews * 15)}</span>
                      </div>
                      <div className="flex items-center justify-between p-3 bg-green-50 rounded-lg">
                        <div className="flex items-center">
                          <i className="ri-calendar-check-line text-green-600 text-xl mr-2"></i>
                          <span className="text-sm text-gray-700">Reservas</span>
                        </div>
                        <span className="font-bold text-green-600">{Math.floor(listing.reviews * 0.8)}</span>
                      </div>
                      <div className="flex items-center justify-between p-3 bg-yellow-50 rounded-lg">
                        <div className="flex items-center">
                          <i className="ri-star-line text-yellow-600 text-xl mr-2"></i>
                          <span className="text-sm text-gray-700">Calificación</span>
                        </div>
                        <span className="font-bold text-yellow-600">{listing.rating}</span>
                      </div>
                      <div className="flex items-center justify-between p-3 bg-purple-50 rounded-lg">
                        <div className="flex items-center">
                          <i className="ri-message-line text-purple-600 text-xl mr-2"></i>
                          <span className="text-sm text-gray-700">Reseñas</span>
                        </div>
                        <span className="font-bold text-purple-600">{listing.reviews}</span>
                      </div>
                    </div>
                  </Card>

                  {/* Share */}
                  <Card className="p-6">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                      <i className="ri-share-line text-green-600 mr-2"></i>
                      Compartir
                    </h3>
                    <div className="flex gap-2">
                      <button className="flex-1 p-3 bg-blue-600 text-white rounded-lg hover:bg-blue-7

                      00 transition-colors cursor-pointer">
                        <i className="ri-facebook-fill text-xl"></i>
                      </button>
                      <button className="flex-1 p-3 bg-sky-500 text-white rounded-lg hover:bg-sky-600 transition-colors cursor-pointer">
                        <i className="ri-twitter-fill text-xl"></i>
                      </button>
                      <button className="flex-1 p-3 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors cursor-pointer">
                        <i className="ri-whatsapp-fill text-xl"></i>
                      </button>
                      <button className="flex-1 p-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors cursor-pointer">
                        <i className="ri-link text-xl"></i>
                      </button>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Reservation Modal */}
      {showReservationModal && (
        <ReservationModal
          listing={listing}
          onClose={handleCloseReservation}
        />
      )}

      <Footer />
    </div>
  );
}

// Reservation Modal Component (reused from advertise page)
const ReservationModal: React.FC<{ listing: any; onClose: () => void }> = ({ listing, onClose }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    fecha: '',
    horaInicio: '',
    horaFin: '',
    duracion: '1',
    numeroPersonas: '',
    tipoReserva: 'individual',
    serviciosAdicionales: [] as string[],
    comentarios: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const serviciosDisponibles = [
    { id: 'balon', label: 'Alquiler de Balón', precio: 50 },
    { id: 'chalecos', label: 'Chalecos de Entrenamiento', precio: 30 },
    { id: 'arbitro', label: 'Árbitro Profesional', precio: 200 },
    { id: 'agua', label: 'Agua Embotellada', precio: 20 },
    { id: 'seguro', label: 'Seguro de Accidentes', precio: 100 }
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleServiceToggle = (serviceId: string) => {
    setFormData(prev => ({
      ...prev,
      serviciosAdicionales: prev.serviciosAdicionales.includes(serviceId)
        ? prev.serviciosAdicionales.filter(id => id !== serviceId)
        : [...prev.serviciosAdicionales, serviceId]
    }));
  };

  const calculateTotal = () => {
    const duracionHoras = parseInt(formData.duracion) || 1;
    const precioBase = listing.price * duracionHoras;
    const precioServicios = formData.serviciosAdicionales.reduce((total, serviceId) => {
      const servicio = serviciosDisponibles.find(s => s.id === serviceId);
      return total + (servicio?.precio || 0);
    }, 0);
    return precioBase + precioServicios;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.nombre || !formData.email || !formData.telefono || !formData.fecha || !formData.horaInicio || !formData.horaFin) {
      alert('Por favor completa todos los campos obligatorios');
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formElement = e.target as HTMLFormElement;
      const formDataToSend = new FormData(formElement);

      const response = await fetch('https://readdy.ai/api/form/d3tehc955ieogu7si8l0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formDataToSend as any).toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Error al enviar reserva:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto border-2 border-red-200">
        <div className="sticky top-0 bg-green-600 text-white p-6 flex items-center justify-between z-10">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-calendar-check-line text-2xl"></i>
            </div>
            <div>
              <h2 className="text-2xl font-bold">Reservar Cancha</h2>
              <p className="text-green-100 text-sm">{listing.name}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center hover:bg-white/20 rounded-full transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>
        </div>

        <form id="reserva-form" data-readdy-form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="bg-gray-50 p-4 rounded-lg border-2 border-red-100">
            <div className="flex items-start gap-4">
              <img
                src={listing.image}
                alt={listing.name}
                className="w-24 h-24 object-cover rounded-lg"
              />
              <div className="flex-1">
                <h3 className="font-bold text-lg text-gray-900">{listing.name}</h3>
                <p className="text-gray-600 text-sm flex items-center gap-1 mt-1">
                  <i className="ri-map-pin-line"></i>
                  {listing.location}
                </p>
                <p className="text-green-600 font-bold text-xl mt-2">${listing.price} MXN/hora</p>
              </div>
            </div>
          </div>

          <input type="hidden" name="cancha" value={listing.name} />
          <input type="hidden" name="ubicacion" value={listing.location} />
          <input type="hidden" name="precioHora" value={listing.price} />
          <input type="hidden" name="total" value={calculateTotal()} />

          <div className="space-y-4">
            <h3 className="font-bold text-lg text-gray-900 flex items-center gap-2">
              <i className="ri-user-line text-green-600"></i>
              Información Personal
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Nombre Completo *
                </label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-green-600 focus:outline-none text-sm"
                  placeholder="Juan Pérez García"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-green-600 focus:outline-none text-sm"
                  placeholder="correo@ejemplo.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Teléfono *
                </label>
                <input
                  type="tel"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-green-600 focus:outline-none text-sm"
                  placeholder="55 1234 5678"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Número de Personas
                </label>
                <input
                  type="number"
                  name="numeroPersonas"
                  value={formData.numeroPersonas}
                  onChange={handleInputChange}
                  min="1"
                  max="22"
                  className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-green-600 focus:outline-none text-sm"
                  placeholder="10"
                />
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="font-bold text-lg text-gray-900 flex items-center gap-2">
              <i className="ri-calendar-line text-green-600"></i>
              Fecha y Horario
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Fecha de Reserva *
                </label>
                <input
                  type="date"
                  name="fecha"
                  value={formData.fecha}
                  onChange={handleInputChange}
                  required
                  min={new Date().toISOString().split('T')[0]}
                  className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-green-600 focus:outline-none text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Duración (horas)
                </label>
                <select
                  name="duracion"
                  value={formData.duracion}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 pr-8 border-2 border-gray-300 rounded-lg focus:border-green-600 focus:outline-none text-sm"
                >
                  <option value="1">1 hora</option>
                  <option value="2">2 horas</option>
                  <option value="3">3 horas</option>
                  <option value="4">4 horas</option>
                  <option value="5">5 horas</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Hora de Inicio *
                </label>
                <input
                  type="time"
                  name="horaInicio"
                  value={formData.horaInicio}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-green-600 focus:outline-none text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Hora de Fin *
                </label>
                <input
                  type="time"
                  name="horaFin"
                  value={formData.horaFin}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-green-600 focus:outline-none text-sm"
                />
              </div>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="font-bold text-lg text-gray-900 flex items-center gap-2">
              <i className="ri-team-line text-green-600"></i>
              Tipo de Reserva
            </h3>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <label className="flex items-center gap-3 p-4 border-2 border-gray-300 rounded-lg cursor-pointer hover:border-green-600 transition-colors">
                <input
                  type="radio"
                  name="tipoReserva"
                  value="individual"
                  checked={formData.tipoReserva === 'individual'}
                  onChange={handleInputChange}
                  className="w-5 h-5 text-green-600"
                />
                <div>
                  <div className="font-medium text-gray-900">Individual</div>
                  <div className="text-xs text-gray-500">Uso personal</div>
                </div>
              </label>

              <label className="flex items-center gap-3 p-4 border-2 border-gray-300 rounded-lg cursor-pointer hover:border-green-600 transition-colors">
                <input
                  type="radio"
                  name="tipoReserva"
                  value="equipo"
                  checked={formData.tipoReserva === 'equipo'}
                  onChange={handleInputChange}
                  className="w-5 h-5 text-green-600"
                />
                <div>
                  <div className="font-medium text-gray-900">Equipo</div>
                  <div className="text-xs text-gray-500">Partido amistoso</div>
                </div>
              </label>

              <label className="flex items-center gap-3 p-4 border-2 border-gray-300 rounded-lg cursor-pointer hover:border-green-600 transition-colors">
                <input
                  type="radio"
                  name="tipoReserva"
                  value="torneo"
                  checked={formData.tipoReserva === 'torneo'}
                  onChange={handleInputChange}
                  className="w-5 h-5 text-green-600"
                />
                <div>
                  <div className="font-medium text-gray-900">Torneo</div>
                  <div className="text-xs text-gray-500">Evento oficial</div>
                </div>
              </label>
            </div>
          </div>

          <div className="space-y-4">
            <h3 className="font-bold text-lg text-gray-900 flex items-center gap-2">
              <i className="ri-service-line text-green-600"></i>
              Servicios Adicionales
            </h3>

            <div className="space-y-2">
              {serviciosDisponibles.map(servicio => (
                <label
                  key={servicio.id}
                  className="flex items-center justify-between p-3 border-2 border-gray-300 rounded-lg cursor-pointer hover:border-green-600 transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <input
                      type="checkbox"
                      checked={formData.serviciosAdicionales.includes(servicio.id)}
                      onChange={() => handleServiceToggle(servicio.id)}
                      className="w-5 h-5 text-green-600 rounded"
                    />
                    <span className="font-medium text-gray-900">{servicio.label}</span>
                  </div>
                  <span className="text-green-600 font-bold">+${servicio.precio} MXN</span>
                </label>
              ))}
              <input
                type="hidden"
                name="serviciosAdicionales"
                value={formData.serviciosAdicionales.map(id => 
                  serviciosDisponibles.find(s => s.id === id)?.label
                ).join(', ')}
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              Comentarios o Solicitudes Especiales
            </label>
            <textarea
              name="comentarios"
              value={formData.comentarios}
              onChange={handleInputChange}
              maxLength={500}
              rows={4}
              className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:border-green-600 focus:outline-none text-sm resize-none"
              placeholder="Escribe aquí cualquier solicitud especial o comentario..."
            />
            <p className="text-xs text-gray-500 text-right">{formData.comentarios.length}/500 caracteres</p>
          </div>

          <div className="bg-green-50 p-4 rounded-lg border-2 border-green-200">
            <h3 className="font-bold text-lg text-gray-900 mb-3">Resumen de Pago</h3>
            <div className="space-y-2">
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Precio por hora:</span>
                <span className="font-medium">${listing.price} MXN</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Duración:</span>
                <span className="font-medium">{formData.duracion} {formData.duracion === '1' ? 'hora' : 'horas'}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-600">Subtotal cancha:</span>
                <span className="font-medium">${listing.price * parseInt(formData.duracion)} MXN</span>
              </div>
              {formData.serviciosAdicionales.length > 0 && (
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600">Servicios adicionales:</span>
                  <span className="font-medium">
                    ${formData.serviciosAdicionales.reduce((total, serviceId) => {
                      const servicio = serviciosDisponibles.find(s => s.id === serviceId);
                      return total + (servicio?.precio || 0);
                    }, 0)} MXN
                  </span>
                </div>
              )}
              <div className="border-t-2 border-green-300 pt-2 mt-2">
                <div className="flex justify-between">
                  <span className="font-bold text-lg text-gray-900">Total:</span>
                  <span className="font-bold text-2xl text-green-600">${calculateTotal()} MXN</span>
                </div>
              </div>
            </div>
          </div>

          {submitStatus === 'success' && (
            <div className="bg-green-100 border-2 border-green-500 text-green-700 px-4 py-3 rounded-lg flex items-center gap-2">
              <i className="ri-check-line text-xl"></i>
              <span className="font-medium">¡Reserva enviada exitosamente! Te contactaremos pronto.</span>
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="bg-red-100 border-2 border-red-500 text-red-700 px-4 py-3 rounded-lg flex items-center gap-2">
              <i className="ri-error-warning-line text-xl"></i>
              <span className="font-medium">Error al enviar la reserva. Por favor intenta nuevamente.</span>
            </div>
          )}

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium cursor-pointer whitespace-nowrap"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="flex-1 px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors font-medium cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? 'Enviando...' : 'Confirmar Reserva'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
